import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3.40267 3.33333H7.40267C7.76934 3.33333 8.06934 3.03333 8.06934 2.66667C8.06934 2.3 7.76934 2 7.40267 2H3.40267C2.66934 2 2.06934 2.6 2.06934 3.33333V12.6667C2.06934 13.4 2.66934 14 3.40267 14H7.40267C7.76934 14 8.06934 13.7 8.06934 13.3333C8.06934 12.9667 7.76934 12.6667 7.40267 12.6667H3.40267V3.33333Z",
			fill: "#151D20"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.836 7.76667L11.976 5.90667C11.7627 5.69333 11.4027 5.84 11.4027 6.14V7.33333H6.736C6.36934 7.33333 6.06934 7.63333 6.06934 8C6.06934 8.36667 6.36934 8.66667 6.736 8.66667H11.4027V9.86C11.4027 10.16 11.7627 10.3067 11.9693 10.0933L13.8293 8.23333C13.9627 8.10667 13.9627 7.89333 13.836 7.76667Z",
			fill: "#151D20"
		})
	]
});
const ForwardRef = forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
